/**
 * label: Card search's label    string
 * style: Card search's style    object
 * type: Card search's type    string
 * inputMode: Card search's input mode    string
 * placeholder: Card search's placeholder    string
 * value: Card search's value    state
 * onChange: Card search's change    function (필수)
 * onClick: Card search's click    function (필수)
 * onKeyDown:  Card search's key down    function(필수)
 * disabled: Card search's disabled    boolean
 *
 */

import React from "react";

function CardSearcher({
	label,
	style,
	type,
	inputMode,
	placeholder,
	value,
	onChange,
	onClick,
	onKeyDown,
	disabled,
}) {
	const InputChange = (e) => {
		onChange(e);
	};

	const InputClick = (e) => {
		onClick(e);
	};

	const InputKeyDown = (e) => {
		onKeyDown(e);
	};

	return (
		<div className="heading with_searcher">
			<div className="searcher">
				<div className="input_set">
					<label>{label}</label>
					<input
						style={style}
						type={type}
						inputMode={inputMode}
						placeholder={placeholder}
						value={value}
						onChange={InputChange}
						onClick={InputClick}
						onKeyDown={InputKeyDown}
						disabled={disabled}
						autoComplete="off"
					/>
				</div>
			</div>
		</div>
	);
}

CardSearcher.defaultProps = {
	label: "",
	type: "text",
	disabled: false,
};

export default CardSearcher;
